import { Component, OnInit, ViewChild, } from '@angular/core';
import { NgForm } from "@angular/forms";
import { DateAdapter } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from "@angular/common";
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { FormControl } from '@angular/forms';
import { debounceTime } from "rxjs/operators";
import { LedgerService } from "./shared/ledger.service";
import { Observable } from 'rxjs';
import { CommonmastersService } from "../../commonmasters/commonmasters.service";

import { ToasterserviceService } from "../../utility/shared/toasterservice.service";
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Toastpayload } from "../../utility/shared/toastpayload";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Message } from '@angular/compiler/src/i18n/i18n_ast';

@Component({
  selector: 'app-ledger',
  templateUrl: './ledger.component.html',
  styleUrls: ['./ledger.component.css']
})
export class LedgerComponent implements OnInit {

  AddButtonText: string;
  ErrorText: string;
  dataSourceList = new MatTableDataSource<any>();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  ParentLedgerNo: number;
  AccountGroupList: any[] = [];
  LedgerList: any[] = [];
  BranchList: any[] = [];
  searchTerm: FormControl = new FormControl();
  public SubLedger: any = {};
  public ledger: any = {};

  public selectedAccountId: Number = 0;

  public ledgerName: string;
  public selectedLedgerId: Number;
  public selectedLedgerName: string;
  public isAllCompany: boolean;
  public BranchId: number = 0;
  public IsBranchDisabled: boolean;
  public IsActive :boolean;
  toast: Toastpayload;

  constructor(private router: Router, private activatedRoute: ActivatedRoute,
    public ledgerService: LedgerService,
    private commonmastersService: CommonmastersService,
    private toasterserviceService: ToasterserviceService,
    private ngxLoader: NgxUiLoaderService
  ) {
    this.resetForm();
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(param => {
      this.ParentLedgerNo = + param['Id'];  //Parent Ledger Id
    });

    this.dataSourceList.paginator = this.paginator;
    this.GetAccountGroupList();
    this.GetBranchList();
    // this.resetForm();

    if (Number.isNaN(this.ParentLedgerNo)) {
      this.ledgerService.selectedLedger.Id = 0;
      this.ledgerService.selectedLedger.Flag = 1;
      this.ledgerService.selectedLedger.IsActive = 1;
      this.IsBranchDisabled = false;
      this.AddButtonText = "Save";
    }
    else {
      this.ledgerService.selectedLedger.Id = +this.ParentLedgerNo;
      this.ledgerService.selectedLedger.Flag = 2;
      // this.ledgerService.selectedLedger.IsActive = 1;
      this.AddButtonText = "Edit & Save";

      this.GetLedgerById();
    }

    this.searchTerm.valueChanges.pipe(debounceTime(700)).subscribe(
      term => {

        if (term !== undefined) {
          this.ledgerService.FetchLedgerByNames(term).subscribe(
            data => {
              if (data.length != 0) {
                this.LedgerList = data;
              }
              else {
                this.LedgerList = null;
              }
            }
          )
        }
      });

  }

  resetForm(form?: NgForm) {
    // if (form != null)
    // form.reset();

    this.ledgerService.selectedLedger = {
      Id: null,
      LedgerName: null,
      IsSubLedger: true,
      SubLedgerId: null,
      SubLedgerName: null,
      AccountId: 0,
      EmployeeId: null,
      EmployeeBranchId: null,
      CompanyId: null,
      SaasId: null,
      IsActive: 1,
      Flag: 1,
      IsAllCompany: false,
      BranchId: null,
      CreatedDate: null,
      IsBranchWise: false,
    }
  }

  public onSubmit(form: NgForm) {

    // <!----- toast Message ----!>
    this.toast = {
      message: "No Message Now!",
      title: 'Ledger',
      ic: {
        timeOut: 3000,
        closeButton: true,
      } as IndividualConfig,
      type: 'success',
    };

    // showing Loader 
    this.ngxLoader.start();
    // <!----- toast Message end----!>

    if (Number.isNaN(this.ParentLedgerNo)) {
      this.ledgerService.selectedLedger.Flag = 1;
      this.ledgerService.selectedLedger.Id = 0;
    }
    else {
      this.ledgerService.selectedLedger.Flag = 2;
      this.ledgerService.selectedLedger.Id = +this.ParentLedgerNo;
    }


    // if ( (this.selectedLedgerName !== 'undefined') || (this.selectedLedgerName !== '')) {
    if (this.selectedLedgerName != '') {
      if (this.selectedLedgerName !== undefined) {
        // this.selectedLedgerId = this.LedgerList.find(item => item.LedgerName == this.selectedLedgerName).Id;
        this.selectedLedgerId = this.LedgerList.find(item => item.SubLedgerName == this.selectedLedgerName).Id;
      }
    }
    else {
      this.selectedLedgerId = 0;
    }

    this.ledgerService.selectedLedger.AccountId = + this.selectedAccountId;
    this.ledgerService.selectedLedger.SubLedgerId = this.selectedLedgerId;
    this.ledgerService.selectedLedger.LedgerName = this.ledger.LedgerName;
    this.ledgerService.selectedLedger.IsAllCompany = this.isAllCompany;
    // this.ledgerService.selectedLedger.BranchId = + this.ledger.BranchId;
    this.ledgerService.selectedLedger.IsActive = this.ledger.IsActive;
    if(!this.IsBranchDisabled){ // All company checking.
      this.ledgerService.selectedLedger.BranchId = + this.BranchId;
    }
    else{
      this.ledgerService.selectedLedger.BranchId = + 0;
    }

    this.ledgerService.IUDLedger(this.ledgerService.selectedLedger)
      .toPromise()
      .then(data => {
        if (data[0].ResponseStatus != 200) {
          this.toast.message = data[0].ResponseMessage; //'Ledger successfully saved!'
          this.toast.type = 'success';
          this.toasterserviceService.showToast(this.toast);
          this.ErrorText = data[0].ResponseMessage
          this.router.navigate(['/ledgerlist']);
        }
        else {
          this.toast.message = data[0].ResponseMessage; //'Ledger failed!'
          this.toast.type = 'error';
          this.toasterserviceService.showToast(this.toast);

        }

      })
      .catch(err => { console.log(err) });

    // Closing Loader
    this.ngxLoader.stop();
  }

  GetLedgerById() {

    if (!Number.isNaN(this.ParentLedgerNo)) {
      this.ledgerService.selectedLedger.Id = this.ParentLedgerNo;
      this.ledgerService.FetchLedgerById(this.ledgerService.selectedLedger).subscribe(data => {

        this.ledgerService.selectedLedger = data;
        this.ledgerService.selectedLedger.Flag = 2;
        this.isAllCompany = data.IsAllCompany;
        this.SubLedger.SubLedgerId = data.SubLedgerId;
        this.selectedAccountId = data.AccountId;
        this.ledger.LedgerName = data.LedgerName;
        this.selectedLedgerName = data.SubLedgerName;
        this.BranchId = data.BranchId;
        this.ledger.IsActive = data.IsActive;
      })
    }
  }

  GetAccountGroupList() {
    this.ledgerService.GetAccountGroupList().subscribe(data => {
      this.AccountGroupList = data;
    })
  }

  GetSubledger(): void {
    console.log("val");
  }

  GetBranchList() {
    this.commonmastersService.GetBranchList().subscribe(data => {
      this.BranchList = data;
    })
  }

  CheckAllCompany(event: Event): void{
    this.IsBranchDisabled = event.target['checked'];
  }

  // updateMySelection(object: any): void {
  //   console.log(object)
  //   this.searchTerm.valueChanges.pipe(debounceTime(700)).subscribe(
  //     term => {

  //       if (term !== undefined ) {
  //         this.ledgerService.FetchLedgerByNames(term).subscribe(
  //           data => {
  //             if(data.length !=0 ){
  //               console.log("Entered");
  //                   console.log(data);
  //                   // this.LedgerList = data as any[];
  //                   this.LedgerList = data ;
  //                   // console.log(this.LedgerList);
  //             }
  //             else{
  //               console.log("Not Entered");
  //             }
  //           }
  //         )
  //       }
  //     });     
  // }
}

